<div *ngIf="chart" class="chart-container">
  <canvas class="chart zoom-in" [id]="canvasName">{{ chart }}</canvas>
</div>
